import "assets/antd.css";
import "assets/QuizComposer.css";
import { Fragment, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import RenderQuizData from 'RenderQuizData/RenderQuizData';
import Logger from 'Logger';
import ImagePreloader from 'ImagePreloader';
import Row from "antd/es/row/index";
import Col from "antd/es/col/index";
import Spin from "antd/es/spin/index";
import message from "antd/es/message";
import QuizDB, { saveQuizLocal,
                 getFirstQuizName, getQuestionIdByName,
                 getFirstQuizQuestionName, } from 'quizdb';
import { setQuizName, setQuestionName, clearResponses,
         setQuizId, setQuestionId, preloadAllMedia, } from 'lib';
import { useSpring, animated } from 'react-spring'
import Spinner from 'react-spinkit';
import Deployments from 'deployments';

Logger.init();
const urlParams = new URLSearchParams(window.location.search);
const quizId = urlParams.get("quiz_id");

function App() {
  const [quiz, setQuiz] = useState();
  const options = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });

  const onLoadDeploymentSuccess = (quiz) => {
    preloadAllMedia(quiz);
    setQuizName(quiz.name);
    setQuizId(quizId);

    const questionName = getFirstQuizQuestionName(quiz);
    setQuestionName(questionName);
    const questionId = getQuestionIdByName(quiz, questionName);
    setQuestionId(questionId);

    clearResponses();

    saveQuizLocal(quiz);
    setQuiz(quiz);
  }

  const onLoadDeploymentFail = (error) => {
    console.error(error);
    message.error(error.toString());
  }

  useEffect(() => {
    Deployments.loadDeployment(quizId, onLoadDeploymentSuccess, onLoadDeploymentFail);
  }, [])

  return (
    <Fragment>
      {
        quiz ?
        <animated.div style={options}>
          <RenderQuizData showEmail={true} quiz={quiz} enableSubmit={true} />
        </animated.div> :
        <Row type="flex" justify="center" align="middle"
             style={{ height: "100vh" }}>
          <Col>
            <Spinner name="pacman" color="#FFEE00"/>
          </Col>
        </Row>
      }
    </Fragment>
  )
}

ReactDOM.render(<App />, document.getElementById("root"));
